<button
  *ngIf="showMapButton()"
  color="secondary"
  mat-menu-item
  id="show_map_widget"
  aria-label="Show location on map"
  matTooltip="Show location on map"
  (click)="showMap()"
>
  <mat-icon>map</mat-icon>  
  <span aria-label="Show on map">Show on map</span>
</button>